export enum WrongTokenVariant {
	ResetPassword = "reset-password",
	FinishRegistration = "finish-registration"
}
export interface WrongTokenDialogProps {
	onClose: () => void;
	onGenerateNewToken: () => void;
	variant: WrongTokenVariant;
}
